<template>
  <base-section
    v-if="hasRenderableContent"
    id="core-advantages"
    space="64"
  >
    <v-container style="max-width: 1160px">
      <base-section-heading
        v-if="moduleTitle || moduleSubtitle"
        :title="moduleTitle || undefined"
        :subtitle="moduleSubtitle || undefined"
        :size="moduleTitleFontSize || undefined"
        :mobile-size="moduleTitleMobileFontSize || 'text-h5'"
        :subtitle-size="moduleSubtitleFontSize || undefined"
        :subtitle-mobile-size="moduleSubtitleMobileFontSize || undefined"
        :is-uppercase="false"
        title-tag="h2"
        :space="6"
      />
      <v-row>
        <v-col
          v-for="(item, index) in items"
          :key="index"
          cols="12"
          md="3"
        >
          <v-card
            class="pa-6 advantage-card"
            outlined
          >
            <div class="advantage-title">
              {{ item.title }}
            </div>
            <div class="advantage-desc">
              {{ item.desc }}
            </div>
            <v-img
              v-if="item.imageUrl"
              :src="item.imageUrl"
              :alt="item.title || 'advantage'"
              class="advantage-image"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionCoreAdvantages',

    data: () => ({
      items: [],
      moduleTitle: '',
      moduleSubtitle: '',
      moduleContent: '',
      moduleTitleFontSize: '',
      moduleTitleMobileFontSize: '',
      moduleSubtitleFontSize: '',
      moduleSubtitleMobileFontSize: '',
    }),

    computed: {
      hasRenderableContent() {
        return Boolean(
          this.items.length ||
            String(this.moduleTitle || '').trim() ||
            String(this.moduleSubtitle || '').trim() ||
            String(this.moduleContent || '').trim(),
        )
      },
    },

    watch: {
      '$i18n.locale'() {
        this.loadItems()
      },
    },

    async mounted() {
      await this.loadItems()
      window.addEventListener('resize', this.equalizeHeights)
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.equalizeHeights)
    },

    methods: {
      equalizeHeights() {
        this.$nextTick(() => {
          const titles = this.$el.querySelectorAll('.advantage-title')
          const descs = this.$el.querySelectorAll('.advantage-desc')
          titles.forEach(el => { el.style.minHeight = '' })
          descs.forEach(el => { el.style.minHeight = '' })
          let maxT = 0
          titles.forEach(el => { maxT = Math.max(maxT, el.offsetHeight) })
          if (maxT > 0) titles.forEach(el => { el.style.minHeight = maxT + 'px' })
          let maxD = 0
          descs.forEach(el => { maxD = Math.max(maxD, el.offsetHeight) })
          if (maxD > 0) descs.forEach(el => { el.style.minHeight = maxD + 'px' })
        })
      },
      async loadItems() {
        try {
          const modules = await this.$axios({
            method: 'get',
            url: '/public/modules/page/home',
            params: { lang: this.$i18n.locale },
          })
          const module = (modules || []).find(item => item?.moduleKey === 'advantages')
          if (module) {
            this.moduleTitle = module.title || ''
            this.moduleSubtitle = module.subtitle || ''
            this.moduleContent = module.content || ''
            this.moduleTitleFontSize = module.titleFontSize || ''
            this.moduleTitleMobileFontSize = module.titleMobileFontSize || ''
            this.moduleSubtitleFontSize = module.subtitleFontSize || ''
            this.moduleSubtitleMobileFontSize = module.subtitleMobileFontSize || ''
          } else {
            this.moduleTitle = ''
            this.moduleSubtitle = ''
            this.moduleContent = ''
            this.moduleTitleFontSize = ''
            this.moduleTitleMobileFontSize = ''
            this.moduleSubtitleFontSize = ''
            this.moduleSubtitleMobileFontSize = ''
          }

          if (module && module.content) {
            const parsed = JSON.parse(module.content)
            this.items = Array.isArray(parsed) ? parsed : []
          } else {
            this.items = []
          }
          this.equalizeHeights()
        } catch (error) {
          this.moduleTitle = ''
          this.moduleSubtitle = ''
          this.moduleContent = ''
          this.moduleTitleFontSize = ''
          this.moduleTitleMobileFontSize = ''
          this.moduleSubtitleFontSize = ''
          this.moduleSubtitleMobileFontSize = ''
          this.items = []
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
.advantage-card
  height: 100%
  display: flex
  flex-direction: column
  border-radius: 0 !important

.advantage-title
  font-size: 18px
  font-weight: 600
  color: rgba(0, 0, 0, 0.9)

.advantage-desc
  margin-top: 10px
  color: rgba(0, 0, 0, 0.7)
  line-height: 1.6
  flex: 1

.advantage-image
  margin-top: 16px
  overflow: hidden
  border-radius: 0
</style>
